import { Firebase } from "../assets";

export let firebase = [
    {
      videoId: "yJUEVTrUcyk",
      time: "47:56",
      icon: Firebase,
      heading: "Introducing Firebase Authentication",
      url: "firebase-introducing-firebase-authentication",
      description: "Learn about the features and benefits of Firebase Authentication.",
     
    },
    {
      videoId: "UMKc5-nAALA",
      time: "47:38",
      icon: Firebase,
      heading: "How to Store Files on Firebase Firestore",
      url: "firebase-how-to-store-files-on-firebase-firestore",
      description: "Discover how to upload and store files using Firebase Firestore.",
     
    },
    {
      videoId: "mGc8FWSMY38",
      time: "23:45",
      icon: Firebase,
      heading: "Firebase Hosting with ReactJS and HTML",
      url: "firebase-hosting-with-reactjs-and-html",
      description: "Explore how to deploy a ReactJS and HTML application to Firebase Hosting.",
   
    },
  ];